export const DevistoLogo = ({ className = "h-8 w-auto", variant = "dark" }) => {
  return (
    <img
      src={variant === "white" ? "/assets/devisto-wordmark-white.svg" : "/assets/devisto-wordmark.svg"}
      alt="Devisto — la plateforme des techniques spéciales du bâtiment"
      className={className}
      loading="eager"
      decoding="sync"
      data-testid="devisto-logo"
    />
  );
};
